import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getSearchCriteria } from "../../../store/searchCriteria/selectors";
import { useSplitBoundsCondition } from "./flights_split_bounds_us";
import useRouteName from "../../../hooks/useRouteName";
import useGlobalContext from "../../../hooks/useGlobalContext";

const utils = createTrackingUtils({
  name: "flights_web_flight_card_update_desktop",
  stages: {
    main: 1,
    roundtrip: 2,
    oneway: 3,
    solo: 4,
    non_solo: 5,
    users_see_flight_cards: 6,
    users_see_dsa_banner: 7,
    users_see_dsa_banner_fly_anywhere: 8,
    dsa_banner_unavailable: 9
  },
  defaultStage: 1,
  goals: {
    open_baggage_info: 1,
    dsa_banner_click: 2,
    dsa_banner_close: 3,
    open_bf_carousel: 4
  }
});

export const useTrackFlightCardUpdateDesktop = () => {
  const { isRountrip, isOneWay, isMobile } = useProfiler();
  const searchCriteria = useSelector(getSearchCriteria);
  const { isSplitBounds } = useSplitBoundsCondition();
  const routeName = useRouteName();

  const travellersCount = searchCriteria.adults + searchCriteria.children.length;

  return useCallback(() => {
    if (isMobile()) return false;
    if (isSplitBounds) return false;
    if (!["fly-anywhere", "searchresults", "flightdetails"].includes(routeName)) return false;

    if (isRountrip()) utils.stages.roundtrip();
    if (isOneWay()) utils.stages.oneway();
    if (travellersCount === 1) utils.stages.solo();
    if (travellersCount > 1) utils.stages.non_solo();

    return !!utils.trackWithDefaultStage();
  }, [isMobile, isOneWay, isRountrip, isSplitBounds, routeName, travellersCount]);
};

export const useTrackFlightCardUpdateDSABannerDesktop = () => {
  const { isRountrip, isOneWay, isMobile } = useProfiler();
  const searchCriteria = useSelector(getSearchCriteria);
  const { isSplitBounds } = useSplitBoundsCondition();
  const routeName = useRouteName();
  const { contentStandardsGuidelines } = useGlobalContext();

  const travellersCount = searchCriteria.adults + searchCriteria.children.length;

  return useCallback(() => {
    if (isMobile()) return false;
    if (isSplitBounds) return false;
    if (!["fly-anywhere", "searchresults", "flightdetails"].includes(routeName)) return false;

    if (!contentStandardsGuidelines) {
      utils.stages.dsa_banner_unavailable();
      return false;
    }

    utils.stages.users_see_dsa_banner();

    if (isRountrip()) utils.stages.roundtrip();
    if (isOneWay()) utils.stages.oneway();
    if (travellersCount === 1) utils.stages.solo();
    if (travellersCount > 1) utils.stages.non_solo();
    if (routeName === "fly-anywhere") utils.stages.users_see_dsa_banner_fly_anywhere();

    return !!utils.trackWithDefaultStage();
  }, [contentStandardsGuidelines, isMobile, isOneWay, isRountrip, isSplitBounds, routeName, travellersCount]);
};

export default utils;
